import cherry from "./cherry.json";
import sa from "./sa.json";

const LEGENDS = {
  cherry: cherry,
  sa: sa,
};

export default LEGENDS;

export const legendOptions = Object.keys(LEGENDS);
